import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import CartToggleComponent from "./CartToggleComponent";
import { BACKEND_BASE_PATH } from "../helpers/config";

//import campaign from "../assets/images/ramadan.png";
const HeaderNavigation = ({ data, menubanner }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  useEffect(() => { }, []);
  console.log();
  return (
    <>

      <div class="col-6 menu-blk d-none d-sm-none d-md-block ">
        <div class="dummy-viewport">
          <div class="horizontal-menu">
            <ul className='horizontal-menu-items'>
              {data.data &&
                data.data.map(({ title, id, slug }) =>
                  <li className='horizontal-menu-item' key={title}>
                    <a
                      href={`/category/${slug}`}
                      className='horizontal-menu-link '
                      title={title}
                    >
                      {title}
                    </a>
                  </li>
                )}
            </ul>
          </div>
        </div>
        <div class="catey__icon">
          <a href="#" class="cate__btn category_drop " title="Categories"><i class="uil uil-apps"></i> Category</a>
        </div>
      </div>



      {/* <nav className='navbar navbar-expand-lg navbar-light py-2'>
        <div className='container-fluid-fluid'>
          <button
            className='navbar-toggler menu_toggle_btn'
            type='button'
            data-target='#navbarSupportedContent'
            onClick={toggle}
          >
            <i className='uil uil-bars'></i>
          </button>
          <div
            className={classNames(
              "collapse navbar-collapse d-flex flex-column flex-lg-row flex-xl-row justify-content-lg-end bg-dark1  p-lg-0 mt1-5  mt-lg-0 mobileMenu",
              { open: isOpen }
            )}
            id='navbarSupportedContent'
          >
            <ul className='navbar-nav main_nav align-self-stretch'>
              {data.data &&
                data.data.map(({ title, id, slug }) =>
                  <li className='nav-item' key={title}>
                    <a
                      href={`/category/${slug}`}
                      className='nav-link '
                      title={title}
                    >
                      {title}
                    </a>
                  </li>
                )}
            </ul>
          </div>
        </div>
      </nav> */}
      <div className="col-3 oc-blk">
        {menubanner.data && (
          <Link to={"/"+menubanner.data.link}>
            <img

              src={`${BACKEND_BASE_PATH}/${menubanner.data.image}`}
              alt='' />
          </Link>

        )}
      </div>
      <CartToggleComponent />
    </>
  );
};

export default HeaderNavigation;
